module.exports = __webpack_public_path__ + "static/media/share-page.7f66ca2e.png";